var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4155 17.1234C37.0928 15.8949 36.1445 14.9257 34.9405 14.598C32.7562 14 24.0008 14 24.0008 14C24.0008 14 15.2438 14 13.061 14.598C11.8555 14.9257 10.9072 15.8933 10.5845 17.1234C10 19.3506 10 24.0008 10 24.0008C10 24.0008 10 28.6494 10.5845 30.8782C10.9072 32.1067 11.8555 33.0759 13.061 33.4036C15.2453 34 24.0008 34 24.0008 34C24.0008 34 32.7562 34 34.9405 33.4036C36.1445 33.0743 37.0943 32.1067 37.4155 30.8782C38 28.6494 38 24.0008 38 24.0008C38 24.0008 38 19.3522 37.4155 17.1234ZM21.2 28.2859V19.7141L28.4744 24.0008L21.2 28.2859Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutube);
export default __webpack_public_path__ + "static/media/ic-youtube.906281e9ae9d63f8b87ed27b032a9c47.svg";
export { ForwardRef as ReactComponent };